import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const FieldHeader = ({ header, subHeader }) => {
	return (
		<Box sx={{ mb: "1rem" }}>
			<Typography variant="h6" gutterBottom sx={{ fontWeight: 400 }}>
				{header}
			</Typography>
			<Typography variant="capton" sx={{ color: "#718096" }} gutterBottom>
				{subHeader}
			</Typography>
		</Box>
	);
};

export default FieldHeader;
